import { render, staticRenderFns } from "./the-side-menu.vue?vue&type=template&id=ee6dce6c&scoped=true&"
import script from "./the-side-menu.vue?vue&type=script&lang=ts&"
export * from "./the-side-menu.vue?vue&type=script&lang=ts&"
import style0 from "./the-side-menu.vue?vue&type=style&index=0&id=ee6dce6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6dce6c",
  null
  
)

export default component.exports